import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        stroke="#D22"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M12 4l-8 8M4 4l8 8"
      />
    </svg>
  )
}

export default Icon
